import React from 'react'
import {Column} from 'react-table'
import {Role} from '../../core/_models'
import {RoleNameCell} from './RoleNameCell'
import {RoleStatusCell} from './RoleStatusCell'
import {RoleActionsCell} from './RoleActionsCell'
import { checkPermission } from 'app/utils/checkPermission'

type CustomColumn<T extends object> = Column<T> & {
  sortable?: boolean
  sortBy?: string
}

export const columns: CustomColumn<Role>[] = [
  {
    Header: 'Name',
    accessor: 'name',
    sortable: true,
    sortBy: 'name',
    Cell: ({value}: {value: string}) => <RoleNameCell name={value} />,
  },
  {
    Header: 'Status',
    accessor: 'status',
    sortable: true,
    sortBy: 'status',
    Cell: ({value}: {value: number}) => <RoleStatusCell status={value} />,
  },
  {
    Header: 'Actions',
    accessor: 'id',
    sortable: false,
    Cell: ({row}: {row: {original: Role}}) => 
      (
        checkPermission('Roles', 'manage') ||
        checkPermission('Roles', 'edit') ||
        checkPermission('Roles', 'view') ||
        checkPermission('Roles', 'delete') ||
        checkPermission('Roles', 'status')
      ) ? (
        <RoleActionsCell id={row.original.id || 0} status={Boolean(row.original.status)} />
      ) : null,
  },
] 